{
  "features": {
    "config": {
      "title": "圣羊的同伴",
      "subtitle": "Twitch 整合设定",
      "sections": {
        "premiumSkins": {
          "title": "特级皮肤",
          "description": "使用此实况互动组件后，你的观众就能成为游戏里的教徒。观众可以自定义自己的教徒，包含使用呼币（Bits）换取特级皮肤。你可以决定换取特级皮肤所需要的呼币数量，或维持免费，让所有人使用这些皮肤。",
          "noBitsOption": "特级皮肤不需要呼币",
          "bitsFeatureNotAvailable": "你的频道无法使用呼币，观众将能任选喜欢的皮肤，不必使用呼币。"
        }
      },
      "actions": {
        "save": "储存变更"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "加入{{channelName}}的教会！",
        "subtitle": "您赢了抽奖！",
        "timeRemaining": "剩余时间：{{time}}",
        "message": "加入本教会有许多好处：有机会长出额外的恶魔附肢，享有把活着的每分每秒都献给圣羊教的荣誉，还有可能被献祭的荣耀！",
        "viewerLinkCta": "参加前，请{share your identity}。",
        "actions": {
          "joinRaffle": "我想入教",
          "joinRaffleViewerHasAlreadyJoined": "您参加了抽奖",
          "dismissRaffle": "谢谢，不用",
          "dismissRaffleViewerHasAlreadyJoined": "关闭"
        },
        "raffleJoinedMessage": "感谢您愿意加入。如果您获选入教，将马上收到通知。您可以关闭此窗口了。"
      },
      "followerBuilder": {
        "title": "建立您的教徒",
        "steps": {
          "intro": {
            "message": "您加入本教会了！您建立的教徒将在游戏里出现。请别忘了，您的教徒最终会死亡，不过至少是为了崇高大业。",
            "actions": {
              "goToNextStep": "建立您的教徒"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "继续"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "回到皮肤",
              "goToNextStep": {
                "variationsForSkin": "继续",
                "noVariationsForSkin": "建立教徒"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "返回颜色",
              "goToNextStep": "建立教徒"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "帮忙",
      "hinder": "阻碍",
      "hhVotingFlyout": {
        "title": "帮忙还是阻碍",
        "message": "参加投票",
        "timeRemaining": "剩余时间：{{time}}",
        "voteCount": "{{amount}} 票"
      },
      "outcomeVotingFlyout": {
        "title": "投票参加{{channelName}}的{{helpOrHinder}}",
        "timeRemaining": "剩余时间：{{time}}"
      }
    }
  }
}
